<template>
  <div>
    <div class='topbg'></div>
    <div style="display: flex; width: 1200px; margin: 0 auto; margin-top: 100px">
      <div class="menu">
        <el-menu active-text-color="#323335" background-color="#FBFBFB" :default-active="defaultmenu"
          text-color="#323335">
          <el-tooltip class="box-item" effect="dark" hide-after="10" placement="right-start"
            v-for="(item, index) in headersList" :key="item.id" :content="item.title">
            <el-menu-item :index="item.id" @click="totip(item.id)">
              <div :style="{ marginLeft: getMarginLeft(item.type) }"></div>
              <span :class="{
                'menu-text-1': item.type === 'header1',
                'menu-text-2': item.type !== 'header1',
              }">
                {{ item.title }}
              </span>
            </el-menu-item>
          </el-tooltip>
        </el-menu>
      </div>
      <!-- 占位 -->
      <div class="menu2"></div>

      <div class="content">
        <div v-if="active == 1">
          <div class="title1" id="1">1.专家库共享目录服务组件简介</div>
          <div class="jj-text1">
            中国招标投标公共服务平台通过电子招标投标公共服务平台网络体系免费提供实现全国工程建设招标投标领域评标专家库共享抽取的公共服务组件,简称"评标专家库共享目录服务组件"。基于"开源、中立、共享、兼容"的原则,通过搭建资源共享网络分布节点,分布式部署评标专家库共享组件,汇集形成评标专家库资源共享目录向各省专家库管理系统提供统一的对接服务。
          </div>

          <div class="jj-text1">
            评标专家库共享组件提供和专家库管理系统的对接和开通功能，包括：评标专家库共享自助开通、查询专家库目录、专家抽取申请、专家抽取结果、专家请假、
            评标专家库共享运行状态监测、用户操作日志记录查询。
          </div>
        </div>

        <div v-if="active == 2" style="height: 100%">
          <div class="title1" id="2">2.专家库共享目录服务组件源码下载</div>

          <div class="tipbox">
            <img src="../../assets/img/ico3.png" alt="" class="downico" />
            <span class="tip-text1">
              &nbsp; &nbsp; &nbsp;发布时间： 2025-02-26 12:21:21
            </span>
          </div>

          <div class="urltext-box">
            <div class="urltext1">专家库共享抽取目录服务组件源码下载链接:</div>

            <div class="urltext2" @click="downym">
              https://gitee.com/cebpubservice
            </div>
          </div>

          <div class="codeimg">
            <img src="../../assets/img/codeview.png" alt="" style="width: 100%; height: 100%" />
          </div>

          <div style="display: flex; margin-top: 24px"></div>

          <div></div>
        </div>

        <div v-if="active == 3">
          <div class="title1" id="3">3.专家库共享目录服务组件对接指南</div>
          <div class="info-text">
            专家库管理系统开发语言为JAVA时,可采用SDK方式对接,以减轻专家库管理系统对接评标专家库共享目录服务组件工作量。
          </div>
          <div class="title1" id="3-1">3.1SDK对接</div>
          <div class="info-text">
            专家库管理系统开发语言为JAVA时,可采用SDK方式对接,以减轻专家库管理系统对接评标专家库共享目录服务组件工作量。
          </div>

          <div class="title2" id="3-1-1">3.1.1 环境依赖</div>

          <div class="info-text">（1）Java运行环境：JDK1.8；</div>

          <div class="info-text">
            （2）网络连通性:确保专家库管理系统与专家库共享目录服务组件服务间网络互通无阻。
          </div>

          <div class="title3" id="3-1-2">3.1.2 专家库管理系统SDK集成</div>

          <div class="title4" id="3-1-2-1">
            3.1.2.1专家库共享抽取SDK集成，用于推送专家抽取结果、推送专家请假信息
          </div>

          <div class="title5" id="3-1-2-1-1">
            第1步：POM文件引入专家库共享抽取SDK
          </div>

          <div class="info-text">
            首先,在项目的pom.xml文件中引入专家库共享抽取SDK及其核心依衣赖包，只需一次引入即可
          </div>

          <showcode :tocode="expertLibraryCode.code1"></showcode>

          <div class="title5" id="3-1-2-1-2">
            第2步：初始化专家库共享抽取SDK中的配置参数
          </div>

          <div class="info-text">
            初始化专家库共享抽取SDK中的配置参数,包括评标专家库共享目录服务组件服务地址serviceUrl、专家库管理系统编码expertLibraryShareCode,clientld、clientSecret、signatureSecret用于专家库管理系统和评标专家库共享目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
          </div>

          <showcode :tocode="expertLibraryCode.code2"></showcode>

          <div class="title3" id="3-1-3">3.1.3 专家库共享抽取工具SDK集成</div>

          <div class="title4" id="3-1-3-1">
            3.1.3.1专家库共享抽取组件SDK集成,用于推送专家抽取申请信息、获取专家抽取终端异地抽取页面访问地址、推送专家抽取取消信息、推送专家抽取中状态、推送专家抽取中状态、专家预查询、查询抽取专业。
          </div>

          <div class="title5" id="3-1-3-1-1">
            第1步:POM文件引入专家库共享抽取组件SDK
          </div>

          <div class="info-text">
            首先,在项目的pom.xml文件中引入专家库共享抽取SDK组件及其核心依赖包,只需一次引入即可
          </div>

          <showcode :tocode="expertLibraryCode.code3"></showcode>

          <div class="title5" id="3-1-3-1-2">
            第2步:初始化专家库共享抽取组件SDK中的配置参数
          </div>

          <div class="info-text">
            初始化专家库共享抽取组件SDK中的配置参数,包括评标专家库共享目录服务组件服务地址serviceUrl、专家库共享抽取工具编码expertLibraryShareExtractToolCode,clientid
            clientSecret、signatureSecret用于专家库共享抽取工具和评标专家库共享目录服务务组件交互通信中的建立安全链路,只需初始化时配置一次：
          </div>

          <showcode :tocode="expertLibraryCode.code4"></showcode>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  reactive,
  toRefs,
  onBeforeUnmount,
  ref,
  shallowRef,
  onMounted,
  nextTick,
} from "vue";
import showcode from "../../components/showcode/index.vue";
import expertLibraryCode from "./codedata/expertLibraryComponent";

//目录标题间距
const getMarginLeft = (type: string) => {
  switch (type) {
    case "header1":
      return "0px";
    case "header2":
      return "10px";
    case "header3":
      return "20px";
    case "header4":
      return "30px";
    case "header5":
      return "40px";
    default:
      return "0px"; // 默认返回0px
  }
};

let active = ref(1);
//点击目录页面滚定
const totip = (id: any) => {
  if (id == 1) {
    active.value = 1;
  } else if (id == 2) {
    active.value = 2;
  } else {
    active.value = 3;
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        // 计算目标元素距离页面顶部的距离
        const top = element.offsetTop - 148;
        // 滚动到该位置，{ behavior: 'smooth' } 表示平滑滚动
        window.scrollTo({
          top: top,
          behavior: "smooth",
        });
      }
    }, 10);
  }
};

const downym = () => {
  window._czc.push(['_trackEvent', '评标专家库目录服务组件', '查看源码', '查看评标专家库目录服务组件源码'])
  window.open("https://gitee.com/cebpubservice", "_blank");
};

let headersList = ref([
  { id: "1", title: "1.组件简介", type: "header1" },
  { id: "2", title: "2.组件源码", type: "header1" },
  { id: "3", title: "3.组件对接指南", type: "header1" },

  { id: "3-1", title: "3.1 SDK对接", type: "header2" },
  { id: "3-1-1", title: "3.1.1 环境依赖", type: "header3" },
  { id: "3-1-2", title: "3.1.2 专家库管理系统SDK集成", type: "header3" },
  { id: "3-1-2-1", title: "3.1.2.1 专家库共享抽取SDK集成", type: "header4" },

  {
    id: "3-1-2-1-1",
    title: "第1步：POM文件引入专家库共享抽取SDK",
    type: "header5",
  },
  {
    id: "3-1-2-1-2",
    title: "第2步：初始化专家库共享抽取SDK中的配置参数",
    type: "header5",
  },

  { id: "3-1-3", title: "3.1.3 专家库共享抽取工具SDK集成", type: "header3" },
  {
    id: "3-1-3-1",
    title: "3.1.3.1 专家库共享抽取组件SDK集成",
    type: "header4",
  },
  {
    id: "3-1-3-1-1",
    title: "第1步：POM文件引入专家库共享抽取组件SDK",
    type: "header5",
  },
  {
    id: "3-1-3-1-2",
    title: "第2步：初始化专家库共享抽取组件SDK中的配置参数",
    type: "header5",
  },
]);

let mode = ref("default"); // 或 'simple'
</script>
<style scoped lang="scss">
@import "./component.scss";
</style>
